import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Message } from '../../../../shared/state/message/message.model';

@Component({
    selector: 'app-message-item',
    templateUrl: './message-item.component.html',
    styleUrls: ['./message-item.component.scss'],
})
export class MessageItemComponent implements OnInit {
    @Input() message: Message;
    @Output() trashClickedEvent = new EventEmitter<Message>();
    @Output() messageClickedEvent = new EventEmitter<Message>();
    @Output() messageModalClickedEvent = new EventEmitter<Message>();
    constructor() {}

    ngOnInit(): void {}

    onTrashClicked(event: Event, message: Message) {
        event.preventDefault();
        event.cancelBubble = true;
        this.trashClickedEvent.emit(message);
    }

    onMessageClicked(message: Message) {
        this.messageClickedEvent.emit(message);
    }

    onMessageModalClicked(message: Message, responsive: boolean) {
        if (window.innerWidth > 768 && responsive) {
            return;
        }
        this.messageModalClickedEvent.emit(message);
    }
}
